import React from 'react'

export default function NotFoundPage() {
  return (
    <div className='not-found-page-container' >
          <img src="/assets/404.png" alt="Page Not Found " data-aos="fade-up"/>
    </div>
  )
}
